<template>
  <v-navigation-drawer
    v-model="drawer"
    absolute
    permanent
    persistent
    width="400"
  >
    <AlertCategoriesList :onSelectCategory="onSelectCategory" />
  </v-navigation-drawer>
</template>
    
  <script>
import { mapState } from "vuex";
import AlertCategoriesList from "../../components/CategoriesList.vue";
export default {
  name: "CategoriesDrawer",
  components: {
    AlertCategoriesList,
  },
  props: {
    onSelectCategory: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      drawer: true,
    };
  },
  computed: {
    ...mapState("alerts", ["categories"]),
  },
  methods: {},
};
</script>
    
  <style scoped>
.v-list {
  background-color: var(--color-surface) !important;
}

.v-navigation-drawer {
  background-color: var(--color-surface) !important;
}
</style>
      
    
      
      